import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Button, Col, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import { getValue } from '@truqc/content-path';
import { v4 as uuidV4 } from 'uuid';
import moment from 'moment';
import React from 'react';
import entityComposition from '../../common/classes/entityComposition';
import SinglePicker from '../../common/controls/singlePicker';
import TextInput from '../../common/controls/textInput';
import Icon from '../../common/containers/icon';
import Facility from './facility';
class OrganizationGeneral extends React.Component {
  constructor(props) {
    super(props);
    this.changeUnitOfAreaID = this.changeUnitOfAreaID.bind(this);
    this.addFacility = this.addFacility.bind(this);
    this.changeFacility = this.changeFacility.bind(this);
    this.removeFacility = this.removeFacility.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
  }
  componentDidMount() {
    const _this$props = this.props,
      facilityEnvironment = _this$props.facilityEnvironment,
      facilityEnvironmentActions = _this$props.facilityEnvironmentActions,
      facilityPrimaryCondition = _this$props.facilityPrimaryCondition,
      facilityPrimaryConditionActions = _this$props.facilityPrimaryConditionActions,
      unitOfArea = _this$props.unitOfArea,
      unitOfAreaActions = _this$props.unitOfAreaActions;
    facilityEnvironmentActions.serverIndex(facilityEnvironment.indexQuery);
    facilityPrimaryConditionActions.serverIndex(facilityPrimaryCondition.indexQuery);
    unitOfAreaActions.serverIndex(unitOfArea.indexQuery);
  }
  changeUnitOfAreaID(value) {
    const onChange = this.props.onChange;
    onChange('unitOfAreaID', value);
  }

  // methods for child facility
  addFacility() {
    const organization = this.props.organization;
    const newFacility = {
      organizationID: organization.id,
      facilityGroups: []
    };
    this.handleAdd('facilities', newFacility);
  }
  changeFacility(index, name, value) {
    const onChange = this.props.onChange;
    onChange("facilities[".concat(index, "]/").concat(name), value);
  }
  removeFacility(index) {
    const _this$props2 = this.props,
      organization = _this$props2.organization,
      onChange = _this$props2.onChange;
    const facilities = organization.facilities || [];
    const newFacilities = JSON.parse(JSON.stringify(facilities));
    newFacilities.splice(index, 1);
    onChange('facilities', newFacilities);
  }

  // generic enough to handle adding: facilities, facilityGroups, facilityGroupAreas
  handleAdd(path, value) {
    const _this$props3 = this.props,
      organization = _this$props3.organization,
      onChange = _this$props3.onChange,
      userID = _this$props3.userID;
    const defaultValue = {
      appCreatorID: userID,
      id: uuidV4().toUpperCase(),
      appCreated: moment().utc().format('YYYY-MM-DD HH:mm:ss')
    };
    const oldValue = getValue(path, organization) || [];
    const newValue = JSON.parse(JSON.stringify(oldValue));
    newValue.push(_objectSpread(_objectSpread({}, defaultValue), value));
    onChange(path, newValue);
  }
  render() {
    const _this$props4 = this.props,
      organization = _this$props4.organization,
      facilityEnvironment = _this$props4.facilityEnvironment,
      facilityPrimaryCondition = _this$props4.facilityPrimaryCondition,
      hasFacilityPermissions = _this$props4.hasFacilityPermissions,
      onChange = _this$props4.onChange,
      unitOfArea = _this$props4.unitOfArea;
    const facilities = organization && organization.facilities || [];
    return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 9
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: "Name",
      field: "name",
      data: organization,
      entity: "Organization",
      placeholder: "Required",
      onChange: onChange
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(SinglePicker, {
      label: "Unit of Area",
      labelKey: "name",
      onChange: this.changeUnitOfAreaID,
      options: unitOfArea.list,
      placeholder: "Select...",
      value: organization.unitOfAreaID,
      returnValueKey: "id",
      searchable: false
    }))), facilities && hasFacilityPermissions ? facilities.map((facility, index) => /*#__PURE__*/React.createElement("div", {
      key: facility.id
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12
    }, /*#__PURE__*/React.createElement("hr", {
      style: {
        marginTop: 10,
        marginBottom: 10
      }
    }))), /*#__PURE__*/React.createElement(Facility, {
      facility: facility,
      key: facility.id,
      index: index,
      onChange: this.changeFacility,
      onRemove: this.removeFacility,
      onAdd: this.handleAdd,
      facilityEnvironments: facilityEnvironment.list,
      facilityPrimaryConditions: facilityPrimaryCondition.list
    }))) : undefined, /*#__PURE__*/React.createElement("hr", null), hasFacilityPermissions ? /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: {
        size: 3,
        offset: 9
      }
    }, /*#__PURE__*/React.createElement(Button, {
      size: "sm",
      className: "form-control t-occ-add-facility tqc-control",
      onClick: this.addFacility
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: "plus"
    }), " New Facility"))) : undefined);
  }
}
OrganizationGeneral.propTypes = {
  facilityEnvironment: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  facilityEnvironmentActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  facilityPrimaryCondition: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  facilityPrimaryConditionActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  organization: PropTypes.shape({
    id: PropTypes.string,
    facilities: PropTypes.arrayOf(PropTypes.shape({})),
    unitOfAreaID: PropTypes.string
  }).isRequired,
  hasFacilityPermissions: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  unitOfArea: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  unitOfAreaActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  userID: PropTypes.string.isRequired
};
export { OrganizationGeneral as TestOrganizationGeneral };
export default entityComposition(OrganizationGeneral, ['facilityEnvironment', 'facilityPrimaryCondition', 'unitOfArea']);